import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "@mui/material/Button";
import CheckboxLabels from "../Components/Checkbox";
import BasicBreadcrumbs from "@material-ui/core/Breadcrumbs";

import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
  CircularProgress,
} from "@material-ui/core";

import { green, orange, red } from "@material-ui/core/colors";

import {
  RemoveRedEye as RemoveRedEyeIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Delete,
} from "@material-ui/icons";
import StarIcon from "@mui/icons-material/Star";
import { spacing } from "@material-ui/system";
import DeleteUser from "../Components/modals/DeleteUser";
import DeleteProduct from "../Components/modals/DeleteProduct";
import {
  HighlightProduct,
  getProducts,
} from "../NetworkCalls/Products/ServerReq";
import ButtonComponent from "../Components/buttton";
import plus from "../Assets/tabler_plus.svg";
import ButtonIconComponent from "../Components/ButtonIcons";
import star_fill from "../Assets/star-icon.svg";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import { GetSingleData, UpdateSingleDoc } from "../NetworkCalls/Admin/ServerReq";

const Divider = styled(MuiDivider)(spacing);


const Categories = () => {
  const boxes = [
  ];
  const [Checkboxes, setCheckboxes] = useState(boxes);
  console.log("Checkboxes")
  console.log(Checkboxes)
  const [loader, setLoader] = useState(false);

  const addCheckboxes = async (e) => {
    const { name, checked } = e.target;
    const update = Checkboxes.map((item) =>
      item.Label === name ? { ...item, Check: !item.Check } : item
    );

    setCheckboxes(update);
    const response = await UpdateSingleDoc('AppInfo', 'categories', { [name]: checked })
  };
  const getData = async () => {
    setLoader(true)
    const response = await GetSingleData('AppInfo', 'categories',)
    console.log("response")
    console.log(response)
    for (const key in response) {
      if (response.hasOwnProperty(key)) {
        const value = response[key];
        console.log("value: " + value)
        boxes.push({ Label: key, Check: value });
      }
    }
    setCheckboxes(boxes)
    console.log(Checkboxes)
    setLoader(false)
  }
  useEffect(() => {
    getData()
  }, [])
  return (
    <React.Fragment>
      <Grid
        style={{ marginBottom: "10px" }}
        justify='space-between'
        container
        spacing={24}>
        <Grid item>
          <Typography
            gutterBottom
            variant='h3'
            display='inline'
            style={{
              fontWeight: "700",
              letteSpacing: "0.2px",
              fontSize: "25px",
            }}>
            Categories
          </Typography>
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <BasicBreadcrumbs />
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />
      <div>
        {loader ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <div className='dashboard_container' style={{ backgroundColor: '#fff', border: '1px solid rgba(76, 78, 100, 0.25)', borderRadius: '10px', padding: '10px' }}>
            <form style={{ width: "97%" }}>
              <Grid
                // style={{ marginBottom: "10px", marginTop: "35px" }}
                container
                spacing={2}>

              </Grid>

              {/* <Grid>
          <Box mt={5}>
            <Typography color='text.primary'>Categories</Typography>
          </Box>
          
        </Grid> */}
              {Checkboxes?.map((item) => (
                <CheckboxLabels
                  onClick={addCheckboxes}
                  check={item?.Check}
                  Label={item?.Label}
                  name={item?.Label}
                />
              ))}

              <Box mt={2}>
                <Typography style={{ color: "#E12F2F" }}>{Error}</Typography>
              </Box>

              <Grid
                container
                justifyContent='center'
                sx={{ marginTop: "30px", width: "50%" }}>
                <ButtonComponent loader={false} name='Save' dashboard={true} />
              </Grid>
            </form>
          </div>
        )
        }
      </div>
    </React.Fragment>
  );
};

export default Categories;
